import { render, staticRenderFns } from "./Settlement.vue?vue&type=template&id=cdd70984&scoped=true"
import script from "./Settlement.vue?vue&type=script&lang=js"
export * from "./Settlement.vue?vue&type=script&lang=js"
import style0 from "./Settlement.vue?vue&type=style&index=0&id=cdd70984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd70984",
  null
  
)

export default component.exports